/* eslint-disable no-plusplus,no-lonely-if */
import { isStringNode, isTagNode } from '@bbob/plugin-helper/lib/index'
import TagNode from '@bbob/plugin-helper/lib/TagNode'

const isStartsWith = (node, type) => (node[0] === type)

const asListItems = (content) => {
  let listIdx = 0
  const listItems = []

  const createItemNode = () => TagNode.create('li')
  const ensureListItem = (val) => {
    listItems[listIdx] = listItems[listIdx] || val
  }
  const addItem = (val) => {
    if (listItems[listIdx] && listItems[listIdx].content) {
      listItems[listIdx].content = listItems[listIdx].content.concat(val)
    } else {
      listItems[listIdx] = listItems[listIdx].concat(val)
    }
  }

  content.forEach((el) => {
    if (isStringNode(el) && isStartsWith(el, '*')) {
      if (listItems[listIdx]) {
        listIdx++
      }
      ensureListItem(createItemNode())
      addItem(el.substr(1))
    } else if (isTagNode(el) && TagNode.isOf(el, '*')) {
      if (listItems[listIdx]) {
        listIdx++
      }
      ensureListItem(createItemNode())
    } else if (!isTagNode(listItems[listIdx])) {
      listIdx++
      ensureListItem(el)
    } else if (listItems[listIdx]) {
      addItem(el)
    } else {
      ensureListItem(el)
    }
  })

  return [].concat(listItems)
}

export default (node) => {
  if (node.attrs.numberlist) {
    return {
      tag: 'ol',
      attrs: {
        class: 'numberlist'
      },
      content: asListItems(node.content)
    }
  } else if (node.attrs.bulletlist) {
    return {
      tag: 'ul',
      attrs: {
        class: 'bulletlist'
      },
      content: asListItems(node.content)
    }
  } else if (node.attrs.checklist) {
    return {
      tag: 'ul',
      attrs: {
        class: 'checklist'
      },
      content: asListItems(node.content)
    }
  }

  return {
    tag: 'ul',
    content: asListItems(node.content)
  }
}
